<div *ngIf="shareObject.data.type=='list' || shareObject.data.type=='deleted'" class="p-3">
    <h1 class="fw-bold fs-4 mb-3">{{'title_employee_relocation'|translate}}</h1>
    <div *ngIf="shareObject.isLoading">
        <div class="">
            <div class="spinner-border spinner-border-sm text-secondary" role="status">
                <span class="visually-hidden">Loading...</span>
            </div>
        </div>
    </div>
    <div *ngIf="!shareObject.isLoading">
        <div class="mt-4 border-bottom">
            <!-- Search bar -->
            <div class="w-100 mb-2">
                <div class="d-flex align-items-center justify-content-between gap-2">
                    <div class="d-flex align-items-center gap-2">
                        <!-- button back  -->
                        <span class="btn btn-sm btn-warning  rounded-1" (click)="sharedService.back()">
                            <i class="bi bi-arrow-left"></i>
                            <span class="ms-2">{{'btn_back'|translate}}</span>
                        </span>
                        <span class="btn btn-sm btn-primary rounded-1" [routerLink]="shareObject.addURL">
                            <i class="bi bi-plus-square"></i>
                            <span class="ms-2">{{'btn_add'|translate}}</span>
                        </span>
                        <!-- link to list deleted -->
                        <span class="btn btn-sm btn-danger rounded-1" [routerLink]="shareObject.deletedURL"
                            *ngIf="shareObject.data.type === 'list'">
                            <i class="bi bi-trash-fill"></i>
                            <span class="ms-2">{{'link_deleted'|translate}}</span>
                        </span>
                        <!-- soft delete  -->
                        <span class="btn btn-sm btn-danger rounded-1"
                            *ngIf="shareObject?.selectedRows.size > 0 && shareObject.data.type === 'list'"
                            (click)="softDeleteItem(shareObject?.selectedRows)">
                            <i class="bi bi-archive"></i>
                            <span class="ms-2">{{'btn_soft_delete'|translate}}</span>
                        </span>
                        <!-- restore many  -->
                        <span class="btn btn-sm btn-success rounded-1"
                            *ngIf="shareObject?.selectedRows.size > 0 && shareObject.data.type === 'deleted'"
                            (click)="restoreItem(shareObject?.selectedRows)">
                            <i class="bi bi-arrow-clockwise"></i>
                            <span class="ms-2">{{'btn_restore'|translate}}</span>
                        </span>
                        <!-- clear  -->
                        <span class="btn btn-sm btn-info rounded-1" (click)="clear()">
                            <i class="bi bi-arrow-clockwise"></i>
                            <span class="ms-2">{{'btn_clear'|translate}}</span>
                        </span>
                        <span class="btn btn-sm btn-primary rounded-1" (click)="shareObject.filterBox = true"
                            role="button">
                            <i class="bi bi-funnel"></i>
                            <span class="ms-2"> {{'btn_filter'|translate}} </span>
                        </span>

                    </div>
                </div>
                <!-- search box -->
                <div style="z-index: 1050; width: 600px" class="position-absolute">
                    <form *ngIf="shareObject.filterBox===true" [formGroup]="filterForm"
                        class="advanced-filters shadow-lg bg-white border rounded p-3 mt-2">
                        <div class="row g-2">
                            <!-- employee keyword -->
                            <div class="col-md-12">
                                <label class="form-label fw-bold" for="keyword">{{'filter_keyword'|translate}}</label>
                                <input type="text" class="form-control form-control-sm" formControlName="keyword"
                                    id="keyword">
                            </div>
                            <!-- page size -->
                            <div class="col-md-4">
                                <label class="form-label fw-bold" for="pagesize">{{"page_size"|translate}}</label>
                                <select class="form-select form-select-sm" formControlName="limit" id="pagesize">
                                    <option *ngFor="let size of sharedService.env.pageSize" value="{{size}}">{{size}}
                                    </option>
                                </select>
                            </div>
                            <div class="col-md-4">
                                <label class="form-label fw-bold" for="date">{{'filter_start_date'|translate}}</label>
                                <input type="date" class="form-control form-control-sm" formControlName="startDate"
                                    id="startDate">
                            </div>
                            <div class="col-md-4">
                                <label class="form-label fw-bold" for="date">{{'filter_end_date'|translate}}</label>
                                <input type="date" class="form-control form-control-sm" formControlName="endDate"
                                    id="endDate">
                            </div>
                            <!-- employee keyword -->
                            <div class="col-md-3">
                                <label class="form-label fw-bold mb-4" for="btns"></label>
                                <div class=" d-flex gap-2" id="btns">
                                    <button class="btn btn-primary btn-sm rounded-1"
                                        (click)="onSearch()">{{'btn_filter'|translate}}</button>
                                    <button class="btn btn-secondary btn-sm rounded-1"
                                        (click)="shareObject.filterBox=false">{{'btn_close'|translate}}</button>
                                    <!-- <button class="btn btn-primary btn-sm rounded-1"
                    (click)="refresh()">{{'btn_clear'|translate}}</button> -->
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
                <!-- filter result -->
                <div class="d-flex gap-2 mb-3 mt-2">
                    <button type="button" *ngIf="shareObject.options.keyword"
                        class="btn btn-outline-primary btn-sm rounded-1 position-relative">
                        {{shareObject.options.keyword}}
                        <span class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger"
                            (click)="filter('keyword',undefined)" role="button">x</span>
                    </button>
                </div>
            </div>
        </div>
        <div class="fix-height">
            <table class="table table-hover table-striped table-sm">
                <thead class="sticky-top bg-white">
                    <tr>
                        <th style="width: 50px;">
                            <div class="form-check">
                                <input class="form-check-input" role="button" type="checkbox"
                                    [checked]="isAllSelected(shareObject.items)"
                                    (change)="toggleSelectAll($event,shareObject.items)" id="checkall">
                                <label class="form-check-label" for="checkall"></label>
                            </div>
                        </th>
                        <th scope="col">{{'relocation_date'|translate}}</th>
                        <th scope="col">{{'relocation_time'|translate}}</th>
                        <th scope="col">{{'relocation_employee'|translate}}</th>
                        <th scope="col">{{'relocation_store'|translate}}</th>
                        <th scope="col">{{'relocation_status'|translate}}</th>
                        <th scope="col">{{'user_editor'|translate}}</th>
                        <th scope="col">{{'use_action'|translate}}</th>
                    </tr>
                </thead>
                <tbody *ngIf="shareObject.items && shareObject.items.length > 0 && !shareObject.isLoading">
                    <tr *ngFor="let item of shareObject.items; let i = index" (click)="selectRow($event, i)"
                        class="align-middle">
                        <td>
                            <div class="form-check">
                                <!-- <input class="form-check-input" role="button" type="checkbox" (change)="checked(item.id)"
                    [checked]="item.checked" id="checkitem"> -->
                                <input class="form-check-input" role="button" type="checkbox"
                                    [checked]="shareObject.selectedRows.has(i)" id="checkitem">
                                <label class="form-check-label" for="checkitem"></label>
                            </div>
                        </td>
                        <td>
                            <span>
                                {{item?.startDate | date: 'dd/MM/yyyy'}} -> {{item?.endDate | date: 'dd/MM/yyyy'}}
                            </span>
                        </td>
                        <td>
                            <span>
                                {{item?.startTime}} -> {{item?.endTime}}
                            </span>
                        </td>
                        <td>
                            <div *ngFor="let employee of item.employees" class="fs-7">
                                <span class=""> {{employee?.profile?.name}} </span>
                            </div>
                        </td>
                        <td>
                            <div class="fs-7">
                                <span class=""> {{item?.store?.name}} </span>
                            </div>
                        </td>
                        <td>
                            <span
                                class="badge rounded-pill text-bg-{{item.status==1?'warning':item.status==2?'primary':'danger'}}">{{item?.statusText}}</span>
                        </td>
                        <td>
                            <span attr.data-title="{{item?.approver?.email}}">
                                {{item?.approver?.profile?.name}}
                            </span>
                        </td>
                        <td>
                            <div class="d-flex gap-2" *ngIf="shareObject.data.type === 'list'">
                                <!-- <span class="btn btn-info btn-sm rounded-1 py-0" (click)="showUserOT(item.employees)">
                                    <i class="bi bi-people me-2"></i>
                                    {{'btn_view'|translate}}
                                </span> -->
                                <span *ngIf="item.status > 1" class="btn btn-primary btn-sm rounded-1 py-0"
                                    [routerLink]="item.editURL">
                                    <i class="bi bi-pencil-square me-2"></i>
                                    {{'btn_edit'|translate}}
                                </span>
                                <span *ngIf="item.status == 1" class="btn btn-primary btn-sm rounded-1 py-0"
                                    (click)="changeStatus(item.id, 2)">
                                    <i class="bi bi-check-circle-fill me-2"></i>
                                    {{'btn_approve'|translate}}
                                </span>
                                <span *ngIf="item.status == 1" class="btn btn-danger btn-sm rounded-1 py-0"
                                    (click)="changeStatus(item.id, 3)">
                                    <i class="bi bi-x-circle-fill me-2"></i>
                                    {{'btn_reject'|translate}}
                                </span>
                                <span class="btn btn-danger btn-sm rounded-1 py-0" (click)="softDeleteItem([i])">
                                    <i class="bi bi-archive me-2"></i>
                                    {{'btn_soft_delete'|translate}}
                                </span>
                            </div>
                            <div class="d-flex gap-2" *ngIf="shareObject.data.type === 'deleted'">
                                <span class="btn btn-primary btn-sm rounded-1 py-0" (click)="restoreItem([i])">
                                    <i class="bi bi-arrow-clockwise me-2"></i>
                                    {{'btn_restore'|translate}}
                                </span>
                                <!-- <span class="btn btn-danger btn-sm rounded-1 py-0" (click)="softDeleteItem([item.id])">
                    <i class="bi bi-archive me-2"></i>
                    {{'btn_soft_delete'|translate}}
                  </span> -->
                            </div>
                        </td>
                    </tr>
                </tbody>
                <caption *ngIf="shareObject.items && shareObject.items.length === 0">
                    <div class="text-center">
                        {{'no_employee_group_found'|translate}}
                    </div>
                </caption>
                <caption *ngIf="shareObject.isLoading">
                    <div class="text-center">
                        <div class="spinner-border spinner-border-sm text-secondary" role="status">
                            <span class="visually-hidden">Loading...</span>
                        </div>
                    </div>
                </caption>
            </table>
        </div>
        <app-pagination [pagingOptions]="shareObject.options" [pagination]="shareObject.pagination"
            (changePage)="onPageChange($event)"></app-pagination>
    </div>
</div>
<div *ngIf="shareObject.data.type=='add' || shareObject.data.type=='edit'">
    <form action="" [formGroup]="formHandle" (ngSubmit)="onSubmit()" class="p-3">
        <div class="row">
            <!-- select user -->
            <div class="mb-3">
                <label for="" class="form-label fw-bold">{{'select_user'|translate}}</label>
                <div class="border p-2">
                    <div class="mb-2">
                        <input type="text" (keyup)="getUsers($event)" class="form-control"
                            placeholder="{{'search_user'|translate}}">
                    </div>
                    <div>
                        <div class="d-flex gap-2 mb-3" *ngIf="shareObject.employees?.pagination?.totalPage> 1">
                            <span role="button" *ngFor="let page of shareObject.employees?.pagination?.pages">
                                <span (click)="changePage(page)"
                                    class="badge text-bg-{{page === shareObject.employees?.pagination?.page ? 'primary' : 'secondary'}} rounded-pill">
                                    {{page}}
                                </span>
                            </span>
                        </div>
                        <div *ngFor="let employee of shareObject.employees?.data">
                            <div class="d-flex gap-2">
                                <input (change)="selectUser(employee.id)" [checked]="employee.checked"
                                    class="form-check-input" role="button" type="checkbox" value=""
                                    id="{{employee.id}}">
                                <label class="" for="{{employee.id}}" role="button"> {{ employee?.profile?.name
                                    }}</label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="mb-3">
                <label for="start" class="form-label fw-bold">
                    {{'relocation_start_date' | translate}}
                    <span class="text-danger">*</span>
                </label>
                <input type="date" id="start" formControlName="startDate" class="form-control">
            </div>
            <div class="mb-3">
                <label for="end" class="form-label fw-bold">
                    {{'relocation_end_date' | translate}}
                    <span class="text-danger">*</span>
                </label>
                <input type="date" id="end" formControlName="endDate" class="form-control">
            </div>
            <div class="mb-3">
                <label for="startTime" class="form-label fw-bold">
                    {{'relocation_start_time' | translate}}
                    <span class="text-danger">*</span>
                </label>
                <input type="time" id="startTime" formControlName="startTime" class="form-control">
            </div>
            <div class="mb-3">
                <label for="endTime" class="form-label fw-bold">
                    {{'relocation_end_time' | translate}}
                    <span class="text-danger">*</span>
                </label>
                <input type="time" id="endTime" formControlName="endTime" class="form-control">
            </div>
            <div class="mb-3">
                <label for="store" class="form-label fw-bold">
                    {{'relocation_store' | translate}}
                    <span class="text-danger">*</span>
                </label>
                <select name="" class="form-select" formControlName="store" id="">
                    <option *ngFor="let store of shareObject.storeList" [value]="store.id">
                        {{store.name}}
                    </option>
                </select>
            </div>
            <div>
                <!-- radio status -->
                <label class="form-label fw-bold">
                    {{'relocation_status' | translate}}
                    <span class="text-danger">*</span>
                </label>
                <div class="d-flex gap-2">
                    <div class="form-check form-check-inline">
                        <input class="form-check-input" type="radio" role="button" formControlName="status" id="status1"
                            value="2">
                        <label class="form-check-label" for="status1" role="button">
                            {{'relocation_status_approve' | translate}}
                        </label>
                    </div>
                    <div class="form-check form-check-inline">
                        <input class="form-check-input" type="radio" role="button" formControlName="status" id="status1"
                            value="3">
                        <label class="form-check-label" for="status1" role="button">
                            {{'relocation_status_reject' | translate}}
                        </label>
                    </div>
                </div>

            </div>
        </div>
        <div class="d-flex gap-2 mt-3">
            <button type="submit" class="btn btn-sm btn-primary">{{'btn_save'|translate}}</button>
            <span class="btn btn-outline-warning btn-sm" routerLink="{{shareObject.listURL}}">
                {{'btn_back'|translate}}
            </span>
        </div>
    </form>
</div>
<div *ngIf="shareObject.data.type=='request'">
    <form action="" [formGroup]="formHandle" (ngSubmit)="onSubmit()" class="p-3">
        <div class="row">
            <!-- select user -->
            <div class="mb-3">
                <label for="start" class="form-label fw-bold">
                    {{'relocation_start_date' | translate}}
                    <span class="text-danger">*</span>
                </label>
                <input type="date" id="start" formControlName="startDate" class="form-control">
            </div>
            <div class="mb-3">
                <label for="end" class="form-label fw-bold">
                    {{'relocation_end_date' | translate}}
                    <span class="text-danger">*</span>
                </label>
                <input type="date" id="end" formControlName="endDate" class="form-control">
            </div>
            <div class="mb-3">
                <label for="startTime" class="form-label fw-bold">
                    {{'relocation_start_time' | translate}}
                    <span class="text-danger">*</span>
                </label>
                <input type="time" id="startTime" formControlName="startTime" class="form-control">
            </div>
            <div class="mb-3">
                <label for="endTime" class="form-label fw-bold">
                    {{'relocation_end_time' | translate}}
                    <span class="text-danger">*</span>
                </label>
                <input type="time" id="endTime" formControlName="endTime" class="form-control">
            </div>
            <div class="mb-3">
                <label for="store" class="form-label fw-bold">
                    {{'relocation_store' | translate}}
                    <span class="text-danger">*</span>
                </label>
                <select name="" class="form-select" formControlName="store" id="">
                    <option *ngFor="let store of shareObject.storeList" [value]="store.id">
                        {{store.name}}
                    </option>
                </select>
            </div>
        </div>
        <div class="d-flex gap-2 mt-3">
            <button type="submit" class="btn btn-sm btn-primary">{{'btn_save'|translate}}</button>
            <span class="btn btn-outline-warning btn-sm" routerLink="/user/profile">
                {{'btn_back'|translate}}
            </span>
        </div>
    </form>
</div>